import { AppFrame, RouterProvider, SessionProvider, Spinner, UpdateBanner, colors, useSession, brandSurface } from '@khaddi/ui';
import { View } from 'react-native';
import { ShipperGate } from './ShipperGate';
import { LoginScreen } from './screens/LoginScreen';

export const SESSION_STORAGE_KEY = 'khaddi.shipper.token';

const SessionGate = () => {
  const { user, restoring } = useSession();
  if (restoring) {
    return (
      <View style={{ flex: 1, justifyContent: 'center', ...brandSurface }}>
        <Spinner color={colors.text} />
      </View>
    );
  }
  return user ? <ShipperGate /> : <LoginScreen />;
};

export const App = () => (
  <SessionProvider storageKey={SESSION_STORAGE_KEY}>
    <RouterProvider>
      <AppFrame defaultNav="top">
        <UpdateBanner />
        <SessionGate />
      </AppFrame>
    </RouterProvider>
  </SessionProvider>
);
